import { combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';
// slices
import dashboardReducer from './slices/dashboard';
import invoiceReducer from './slices/invoice';
import invoiceSaleReducer from './slices/invoiceSale';
import invoicePurchaseReducer from './slices/invoicePurchase';
import invoiceNoteReducer from './slices/invoiceNote';
import invoicePrepaymentReducer from './slices/invoicePrepayment';
import expenseReducer from './slices/expense';
import paymentReducer from './slices/payment';
import stockTransferReducer from './slices/stockTransfer';
import stockAdjustmentReducer from './slices/stockAdjustment';
import stockTransactionReducer from './slices/stockTransaction';
import partnerReducer from './slices/partner';
import partnerCustomerReducer from './slices/partnerCustomer';
import partnerSupplierReducer from './slices/partnerSupplier';
import productReducer from './slices/product';
import categoryProductReducer from './slices/categoryProduct';
import paymentMethodReducer from './slices/paymentMethod';
import historyLogReducer from './slices/historyLog';
import branchReducer from './slices/branch';
import teamReducer from './slices/team';
import memberReducer from './slices/member';
import attachmentReducer from './slices/attachment';
import reportSaleReducer from './slices/reportSale';
import reportPurchaseReducer from './slices/reportPurchase';
import reportExpenseReducer from './slices/reportExpense';
import reportTaxReducer from './slices/reportTax';
import reportProfitLossReducer from './slices/reportProfitLoss';
import reportStockReducer from './slices/reportStock';
import reportDispatchReducer from './slices/reportDispatch';
import projectReducer from './slices/project';
import egsReducer from './slices/egs';
import accountsReducer from './slices/accounts';
import accountStatementReducer from './slices/accountStatement';
import trialBalanceReducer from './slices/trialBalance';
import profitLossReducer from './slices/profitLoss';
import balanceSheetReducer from './slices/balanceSheet';
import journalReducer from './slices/journal';
import journalEntryReducer from './slices/journalEntry';
import expensesAccountsReducer from './slices/expensesAccounts';
import defaultAccountsReducer from './slices/defaultAccounts';
import hrHolidayReducer from './slices/hrHoliday';
import hrDepartmentReducer from './slices/hrDepartment';
import hrEmployeeReducer from './slices/hrEmployee';
import hrVacationReducer from './slices/hrVacation';
import hrVacationTypeReducer from './slices/hrVacationType';
import hrVacationPolicyReducer from './slices/hrVacationPolicy';
import hrPayrollReducer from './slices/hrPayroll';
import hrAttendanceReducer from './slices/hrAttendance';
import hrMeReducer from './slices/hrMe';
import hrDashboardReducer from './slices/hrDashboard';
import portalDashboardReducer from './slices/portalDashboard';
import chatReducer from './slices/chat';

// ----------------------------------------------------------------------

const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  whitelist: [],
};

const rootReducer = combineReducers({
  dashboard: dashboardReducer,
  invoice: invoiceReducer,
  invoiceSale: invoiceSaleReducer,
  invoicePurchase: invoicePurchaseReducer,
  invoiceNote: invoiceNoteReducer,
  invoicePrepayment: invoicePrepaymentReducer,
  expense: expenseReducer,
  payment: paymentReducer,
  stockTransfer: stockTransferReducer,
  stockAdjustment: stockAdjustmentReducer,
  stockTransaction: stockTransactionReducer,
  partner: partnerReducer,
  partnerCustomer: partnerCustomerReducer,
  partnerSupplier: partnerSupplierReducer,
  product: productReducer,
  categoryProduct: categoryProductReducer,
  paymentMethod: paymentMethodReducer,
  historyLog: historyLogReducer,
  branch: branchReducer,
  team: teamReducer,
  project: projectReducer,
  member: memberReducer,
  attachment: attachmentReducer,
  reportSale: reportSaleReducer,
  reportPurchase: reportPurchaseReducer,
  reportExpense: reportExpenseReducer,
  reportTax: reportTaxReducer,
  reportProfitLoss: reportProfitLossReducer,
  reportStock: reportStockReducer,
  reportDispatch: reportDispatchReducer,
  egs: egsReducer,
  accounts: accountsReducer,
  accountStatement: accountStatementReducer,
  trialBalance: trialBalanceReducer,
  profitLoss: profitLossReducer,
  balanceSheet: balanceSheetReducer,
  journal: journalReducer,
  journalEntry: journalEntryReducer,
  expensesAccounts: expensesAccountsReducer,
  defaultAccounts: defaultAccountsReducer,
  hrHoliday: hrHolidayReducer,
  hrDepartment: hrDepartmentReducer,
  hrEmployee: hrEmployeeReducer,
  hrVacation: hrVacationReducer,
  hrVacationType: hrVacationTypeReducer,
  hrVacationPolicy: hrVacationPolicyReducer,
  hrPayroll: hrPayrollReducer,
  hrAttendance: hrAttendanceReducer,
  hrMe: hrMeReducer,
  hrDashboard: hrDashboardReducer,
  portalDashboard: portalDashboardReducer,
  chat: chatReducer,
});

export { rootPersistConfig, rootReducer };
